import axios from '../config/axios';

const PAYMENT_API = '/commission-payments';

const commissionPaymentService = {

  createPayment: (formData) =>
    axios.post(PAYMENT_API, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  updatePayment: (paymentId, formData) =>
    axios.put(`${PAYMENT_API}/${paymentId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  deletePayment: (paymentId) =>
    axios.delete(`${PAYMENT_API}/${paymentId}`),

  getPayment: (paymentId) =>
    axios.get(`${PAYMENT_API}/${paymentId}`),

  getAllPayments: (page = 1, perPage = 20, filters = {}) =>
    axios.get(PAYMENT_API, { params: { page, per_page: perPage, ...filters } }),

  getPaymentsByCommission: (commissionId) =>
    axios.get(PAYMENT_API, { params: { commission_id: commissionId, all: 'true' } }),

  getPaymentsByRecipient: (recipientType, recipientId) =>
    axios.get(PAYMENT_API, {
      params: { recipient_type: recipientType, recipient_id: recipientId, all: 'true' },
    }),

  getFileAttachmentUrl: (paymentId) =>
    `${axios.defaults.baseURL}${PAYMENT_API}/${paymentId}/file-attachment`,
};

export default commissionPaymentService;